export const toDefenderInputCreateRequest = ({
  tenantId,
  clientId,
  defenderName,
  defenderThrottleEnabled,
  pollingInterval,
  clientSecret,
  subscriptionType
}) => ({
  name: defenderName.value,
  polling_interval: pollingInterval.value,
  polling_time_unit: "MINUTES",
  defender_tenant_id: tenantId.value,
  enable_throttling: !!(defenderThrottleEnabled == null ? void 0 : defenderThrottleEnabled.value),
  defender_client_id: clientId.value,
  defender_client_secret: clientSecret.value,
  defender_subscription_type: subscriptionType.value
});
export const toGenericInputCreateRequest = ({
  tenantId,
  clientId,
  defenderName,
  defenderThrottleEnabled,
  pollingInterval,
  clientSecret,
  subscriptionType
}) => ({
  type: "org.graylog.enterprise.integrations.microsoftdefender.DefenderInput",
  title: defenderName.value,
  global: false,
  configuration: {
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES",
    tenant_id: tenantId.value,
    throttling_allowed: !!(defenderThrottleEnabled == null ? void 0 : defenderThrottleEnabled.value),
    client_id: clientId.value,
    client_secret: clientSecret.value,
    subscription_type: subscriptionType.value
  }
});
